import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Price from './Price';
import PriceDiffrencePercentage from './PriceDiffrencePercentage';
import PriceDiffrenceBetween from './PriceDiffrenceBetween';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
  },
}));

const PriceContainer = ({ symbol }) => {
  const classes = useStyles();
  return (
    <div className={`${classes.root} PriceContainer`}>
      <Price symbol={symbol} /> <PriceDiffrenceBetween symbol={symbol} />{' '}
      <PriceDiffrencePercentage symbol={symbol} />
    </div>
  );
};

export default PriceContainer;
